// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__1NMw1","validationTips":"StatementDescriptor_validationTips__2XVYw"};